import { graphql, useStaticQuery } from 'gatsby';

const useHvacClimateMap = () => {
  const { allContentfulWebsiteImage } = useStaticQuery(graphql`
    query {
      allContentfulWebsiteImage(
        filter: {
          contentful_id: {
            in: [
              "1AzJ5vKZYUtpfvj0YcKPde" #HVAC Climate Map
            ]
          }
        }
      ) {
        edges {
          node {
            internalName
            image {
              file {
                url
              }
            }
          }
        }
      }
    }
  `);

  return allContentfulWebsiteImage?.edges;
};

export default useHvacClimateMap;
